import { useCallback } from 'react';
import { useSearchParams } from 'react-router';
import { REPORT_RANGE_KEYS, type ReportRangeKey } from '@/lib/report-range';

/**
 * RAPOR ARALIGI <-> ADRES CUBUGU koprusu.
 *
 * Aralik URL'de tutuluyor ki bir rapor gorunumu PAYLASILABILSIN ve yenileme
 * secimi kaybetmesin — "90 gun" secip sayfayi tazeleyen kullanicinin 30 gune
 * geri dusmesi, rakamlarin degistigini fark etmedigi bir hata sinifi uretir.
 *
 * `replace: true`: aralik degisimi gecmis yiginina KAYIT BIRAKMAZ; aksi halde
 * geri tusuyla rapordan cikmak icin her secime bir kez basmak gerekirdi
 * (src/features/tasks/useUrlList.ts ayni gerekceyle boyle).
 *
 * BILINMEYEN DEGER VARSAYILANA DUSER. URL kullanicinin (ve baglantiyi
 * gonderenin) yazabildigi bir alan; `?aralik=hepsi` gibi bir deger ekrani
 * cokertmemeli.
 */
const PARAM = 'aralik';
const DEFAULT_RANGE: ReportRangeKey = '30d';

const isRangeKey = (value: string | null): value is ReportRangeKey =>
  value !== null && (REPORT_RANGE_KEYS as readonly string[]).includes(value);

export const useUrlRange = (): [ReportRangeKey, (next: ReportRangeKey) => void] => {
  const [searchParams, setSearchParams] = useSearchParams();

  const raw = searchParams.get(PARAM);
  const range: ReportRangeKey = isRangeKey(raw) ? raw : DEFAULT_RANGE;

  const setRange = useCallback(
    (next: ReportRangeKey) => {
      const params = new URLSearchParams(searchParams);
      // Varsayilan aralik URL'e YAZILMAZ: temiz adres, paylasilan baglantiyi
      // okunur tutuyor ve "hangi gorunum varsayilan" sorusunu tek yerde birakiyor.
      if (next === DEFAULT_RANGE) params.delete(PARAM);
      else params.set(PARAM, next);
      setSearchParams(params, { replace: true });
    },
    [searchParams, setSearchParams],
  );

  return [range, setRange];
};
